'use strict';

exports.__esModule = true;
var normalizeHtml = function normalizeHtml(html) {
  return html.replace('\n', '<br>');
};

exports.default = normalizeHtml;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-live/lib/utils/normalizeHtml.js
// module id = 973
// module chunks = 35783957827783